import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import OnboardingForm from "@components/Onboarding/OnboardingForm/OnboardingForm";
import { useTranslation } from "react-i18next";
import OnboardingCharactersForm from "@components/Onboarding/OnboardingCharacterForm/OnboardingCharactersForm";
import PortraitIcon from "@mui/icons-material/Portrait";
import {
  isAddPatientFlow,
  withOnboardingFlow,
} from "@components/Onboarding/onboardingFlow";

const Characters: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { id } = useParams();
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const location = useLocation();
  const isPatientOnlyFlow = isAddPatientFlow(location.search);
  const effectivePatientId = id || (isPatientOnlyFlow ? null : patientId);
  const { data: patient, isLoading } = useGetPatientQuery(effectivePatientId!, {
    skip: !effectivePatientId,
  });
  const { t } = useTranslation();

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate(withOnboardingFlow("/onboarding/profile", location.search));
    }
  }, [patient, accountId, navigate, isLoading, location.search]);

  return (
    <>
      {isLoading || !patient ? (
        <Loader />
      ) : (
        <OnboardingForm
          title={t("characters.title")}
          subtitle={t("characters.subtitle", {
            patientNickName: patient?.nickname || patient?.firstName || "",
          })}
          icon={<PortraitIcon fontSize="small" />}
        >
          <OnboardingCharactersForm patient={patient} />
        </OnboardingForm>
      )}
    </>
  );
};

export default Characters;
